<template>
  <div class="about-content">
    <div class="details-top">
      <form action="/" class="logo-container">
        <van-search
          v-model="searchContent"
          right-icon=""
          shape="round"
          placeholder="搜索内容"
          @search="onCourseSearchEnter"
          :clearable="true"
          clear-trigger="always"
          @clear="clearSearchValue"
        >
          <template #left-icon>
            <van-icon name="search"/>
          </template>
        </van-search>
      </form>
      <select-course-tabs :tabsData="tabsData" :titleActive="titleActive" @onClickTab="onClickTab" />
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      class="con-list"
    >
      <div
        class="con-item"
        v-for="(item, index) in searchList"
        :key="index"
        @click="handleClickItems(index)"
      >
        <img
          src="@/assets/images/cartojourney/img20.png"
          v-if="item.isCheck"
          class="icon-item"
          alt=""
        />
        <img
          src="@/assets/images/teacher-task/un-select.png"
          v-else
          class="icon-item"
          alt=""
        />
        <div class="item-con">
          <img :src="item.coverUrl || item.coverMaterialUrl" class="con-cover" alt=""/>
          <div class="con-txt">
            <div class="txt-title">{{ item.title || item.name }}</div>
            <div class="txt-tag">讲师: {{ item.keynoteSpeaker || item.courseLecturers }}</div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="confirm-btn" @click="handleConfirm">确认选择</div>
  </div>
</template>
<script>
// import { getDatabaseCoursesList } from '@/api/database.js'
import {selectCjDataBanklistPage} from '@/api/cartoJourney.js'
import withRouteTracking from '@/utils/withRouteTracking'
import {debounce} from '@/utils/util'
import SelectCourseTabs from './components/SelectCourseTabs.vue'
import {selectCourseTabs} from './components/data'
import {homeSearch} from '../../api/api'
import {handleTraceSearchLog} from '../../utils/trace'

const UserProfile = {
  data() {
    return {
      searchContent: '',
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      type: '1',
      searchList: [],
      pageSource: '', // 页面来源
      tabsData: selectCourseTabs,
      titleActive: '1'
    }
  },
  components: {
    SelectCourseTabs
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  mounted() {
    const {customizedCode, customizedJourneyId, customizedStageId, pageSource} = this.$route.query
    this.customizedCode = customizedCode
    this.customizedJourneyId = customizedJourneyId
    this.customizedStageId = customizedStageId
    this.pageSource = pageSource
  },
  methods: {
    onClickTab(e) {
      if (this.loading) return
      this.eachStorage()
      this.titleActive = e
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      this.onLoad()
    },
    onCourseSearchEnter: debounce(function (e) {
      if (this.loading) return
      this.eachStorage()
      if (e) {
        this.searchContent = e
      }
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': this.searchContent,
        'sessionId': localStorage.getItem('sessionId'),
        'type': 9,
        'entrance': 56,
      })
      this.onLoad()
      return false
    }, 500),
    onLoad() {
      this.loading = true
      let obj
      if (this.titleActive === '1' || this.titleActive === '3') {
        obj = homeSearch({
          'userId': this.userInfo.id,
          'searchContent': this.searchContent,
          'type': this.titleActive, // '1文献 3病例',
          'pageNum': this.pageNum,
          'pageSize': this.pageSize
        })
      }
      if (this.titleActive === '2') { // 2课程
        obj = selectCjDataBanklistPage({
          userId: this.userInfo.id,
          dataValue: this.searchContent,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
      }
      obj.then((res) => {
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        let selectCourse = []
        if (sessionStorage.getItem('selectCourse')) {
          selectCourse = JSON.parse(sessionStorage.getItem('selectCourse'))
        }
        res.data.list.map((item) => {
          item.isCheck = false
          if (selectCourse && selectCourse.length > 0) {
            selectCourse.map((changeItem) => {
              if (changeItem.courseId === item.id || changeItem.courseId === item.baseId) {
                item.isCheck = true
              }
            })
          }
        })
        this.searchList = this.searchList.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.searchList.length <= 0) {
          this.isSearch = true
        } else {
          this.isSearch = false
        }
        this.pageNum++
      })
    },
    eachStorage() {
      let storageCon = []

      // 从sessionStorage中获取已有的选中项
      if (sessionStorage.getItem('selectCourse')) {
        storageCon = JSON.parse(sessionStorage.getItem('selectCourse'))
      } else {
        storageCon = []
      }

      // 根据当前类型获取对应的选中项列表
      const currentSelected = this.searchList.filter(res => res.isCheck)

      // 创建一个Map来存储已有的选中项，以id为键
      const existingMap = new Map(storageCon.map(item => [item.courseId, item]))

      // 合并当前选中项到已有的选中项中，避免重复
      currentSelected.forEach(item => {
        if (this.titleActive === '1' || this.titleActive === '3') {
          if (!existingMap.has(item.baseId)) {
            existingMap.set(item.baseId, {
              courseId: item.baseId,
              baseType: this.titleActive,
              docuCourseCase: {
                coverUrl: item.coverUrl,
                title: item.title,
                keynoteSpeaker: item.keynoteSpeaker
              }
            })
          }
        }
        if (this.titleActive === '2') {
          if (!existingMap.has(item.id)) {
            existingMap.set(item.id, {
              courseId: item.id,
              baseType: this.titleActive,
              docuCourseCase: {
                coverUrl: item.coverMaterialUrl,
                title: item.name,
                keynoteSpeaker: item.courseLecturers
              }
            })
          }
        }
      })

      // 遍历缓存中的每一项，检查是否在当前显示的列表中且未被勾选
      storageCon.forEach(item => {
        const currentItem = this.searchList.find(res => res.baseId === item.courseId || res.id === item.courseId)
        if (currentItem && !currentItem.isCheck) {
          existingMap.delete(item.courseId)
        }
      })

      // 更新storageCon
      storageCon = Array.from(existingMap.values())

      // 保存到sessionStorage
      sessionStorage.setItem('selectCourse', JSON.stringify(storageCon))
    },

    clearSearchValue(e) {
      this.onCourseSearchEnter()
    },

    handleClickItems(index) {
      this.searchList[index].isCheck = !this.searchList[index].isCheck
      this.eachStorage()
    },
    handleConfirm: debounce(function () {
      this.eachStorage()
      this.$router.go(-1)
    }, 500),
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.about-content {
  height: 100vh;
  overflow-y: auto;
  width: 100%;
  background: linear-gradient(180deg, #edf1f4 0%, #f2f7fa 100%);
  padding-top: 109px;
  box-sizing: border-box;
  padding-bottom: 50px;
  background: #F9F8F7;

  .details-top {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    background: #F9F8F7;

    .logo-container {
      height: 62px;

      /deep/ .van-search {
        background-color: transparent;
        height: 100%;

        .van-search__content {
          border: 1px solid #F1EFED;
          background: rgba(255, 255, 255, 0.5);
          .van-field__control {
            color: #949BA5;
            font-weight: 400;
            font-size: 13px;
            &::placeholder {
              color: #949BA5;
              font-weight: 400;
              font-size: 13px;
            }
          }
        }
      }
    }
  }

  .con-list {
    padding: 10px 16px;
    box-sizing: border-box;

    .con-item {
      background-color: #fff;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      border-radius: 12px;

      .icon-item {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .item-con {
        display: flex;
        align-items: flex-start;

        .con-cover {
          width: 110px;
          height: 60px;
          object-fit: cover;
          margin-right: 6px;
          min-width: 110px;
          border-radius: 6px;
          overflow: hidden;
        }

        .con-txt {
          font-size: 14px;

          .txt-title {
            color: #000000;
            font-weight: 500;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .txt-tag {
            color: #b1b1b1;
          }
        }
      }
    }
  }

  .confirm-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    font-size: 16px;
    text-align: center;
    line-height: 42px;
    font-weight: 500;
    color: #fff;
    background-color: #eb1700;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/selectCourse.vue